
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"22","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16.972 16l-3.525 5.647a2.285 2.285 0 01-3.895 0l-3.53-5.645C2.914 16.736 0 18.085 0 19.697 0 22.492 6.41 24 11.5 24S22 22.492 22 19.697c0-1.613-1.918-2.962-5.028-3.697z","fill":"#97025B"}}),_c('path',{attrs:{"d":"M11.5 0C7.41 0 4 3.327 4 7.574c0 1.616.48 3.057 1.404 4.407l5.522 8.702a.678.678 0 001.148 0l5.546-8.732A7.591 7.591 0 0019 7.574C19 3.398 15.636 0 11.5 0zm0 11.017c-1.88 0-3.41-1.545-3.41-3.443 0-1.898 1.53-3.443 3.41-3.443 1.88 0 3.41 1.545 3.41 3.443 0 1.898-1.53 3.443-3.41 3.443z","fill":"#97025B"}})])
          )
        }
      }
    